import { AutocompleteWithLabel, InputWithLabel } from '@adotel/components'
import { useLazyQuery } from '@apollo/client'
import SearchIcon from '@material-ui/icons/Search'
import { useEffect } from 'react'

import { PROVIDERS_QUERY } from '../../graphql/providerQueries'
import { convertPersianNumbersToEnglishNumbers } from '../../helpers/numbers'
import { getTranslate } from '../../localization'
import { ProviderBrief } from '../../types/provider'
import useStyles from './styles/TemplatesFilters.styles'

interface TemplatesFiltersProps {
  setAutoCompleteForProviderCode: (rt: string) => void
  inputValue: string | undefined
  setinputVal: (val: string) => void
  loadingForDisableSearchBox: boolean
  autoCompleteForProviderCode: any
  hasAccessToChangeProvider: boolean | undefined
}

const TemplatesFilters: React.FC<TemplatesFiltersProps> = ({
  setAutoCompleteForProviderCode,
  inputValue,
  setinputVal,
  loadingForDisableSearchBox,
  autoCompleteForProviderCode,
  hasAccessToChangeProvider
}) => {
  const classes = useStyles()

  const [getProviders, { data: providerData, loading: loadingForProvider }] =
    useLazyQuery<{
      providers: ProviderBrief[]
    }>(PROVIDERS_QUERY, {
      notifyOnNetworkStatusChange: true
    })

  useEffect(() => {
    if (hasAccessToChangeProvider) {
      getProviders()
    }
  }, [])

  return (
    <div
      className={[
        classes.root,
        !hasAccessToChangeProvider ? classes.rootForProviderRole : ''
      ].join(' ')}>
      {hasAccessToChangeProvider && (
        <div>
          <AutocompleteWithLabel
            placeholder={getTranslate('Please select a provider')}
            value={autoCompleteForProviderCode}
            getOptionLabel={(option) => option.label || ''}
            getOptionSelected={(option, value) => option.value === value.value}
            options={
              providerData?.providers.map((item) => ({
                label: `${item.name} - (${item.displayProviderCode})`,
                value: item.providerCode
              })) || []
            }
            onChange={(_, value: any) => {
              setAutoCompleteForProviderCode(value)
              setinputVal('')
            }}
            fullWidth
            noHelperText
            inputSize="small"
            loading={loadingForProvider}
            loadingText={getTranslate('Loading') + '...'}
          />
        </div>
      )}
      <div>
        <InputWithLabel
          placeholder={getTranslate('Search in templates names')}
          autoComplete="off"
          noHelperText
          fullWidth
          startIcon={<SearchIcon />}
          inputSize="small"
          value={inputValue}
          onChange={(event) =>
            setinputVal(
              convertPersianNumbersToEnglishNumbers(event.currentTarget.value)
            )
          }
          disabled={loadingForDisableSearchBox}
        />
      </div>
    </div>
  )
}

export default TemplatesFilters
